import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import FormikInputField from 'components/common/Fields/FormikInputField';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import { Field, Formik } from 'formik';
import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, Col, Container, FormGroup, Input, InputGroup, InputGroupText, Label, Row, UncontrolledTooltip } from 'reactstrap';
import Calendar from "assets/icon/calendar-icon.svg";
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactSelect from 'react-select';
import AddWholesalers from '../AddWholeSalers';
import Drawer from 'components/Drawer';
import useContextService from 'hooks/useContextService';
import { Option, LimitedChipsContainer } from 'components/Options';
import useAxios from 'hooks/useAxios';
import { cloneDeep } from 'lodash';
import reseticon from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";
import plus from "assets/icon/plus-icon.svg";
import { ModuleAccess } from 'utils/moduleaccess';


let SelectedAccumulator = "";
let hasDatePopupOpen = false;
let coveredEntityError = "Covered Entity is a required field";
let accumulationError = "Accumulator is a required field";

let coveredEntitiesData = [];
let accumulationData = [];
let accountTypeData = [];

const SearchContainer = (props) => {
  const API = useAxios();

  const {
    states: { drugWholeSaler },
    setStates,
    resetStates,
  } = useContextService();

  const { coveredEntity, searchTerms, accumulations } = drugWholeSaler;

  let {
    coveredEntityIDs,
    coveredEntityID,
    accumulationIDs,
   
    accountTypeId,

  } = searchTerms;

  const updateStates = (drugWholeSaler) => {
    setStates("drugWholeSaler", drugWholeSaler);
  };

  const { orgId, onReset, onSearch, refetch,reset } = props;

  useEffect(() => {
    fetchAccountType();
    SelectedAccumulator="";
  }, []);


  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  const [activeButton, setActiveButton] = useState("All");
  const [addwholesalers, setAddwholesalers] = useState(false)
  const [hasACCSelected, setACCSelected] = useState(true);
  const [hasCESelected, setCESelected] = useState(true);
  const [isSubmited, serIsSubmitted] = useState(false);
  const [selectedCEOption, setCEOptionSelected] = useState({
    optionCESelected: "-1",
  });
  const [selectedACCOption, setOptionACCSelected] = useState({
    optionACCSelected: "-1",
  });
  //const [SelectedAccumulator, setSelectedAccumulator] = useState("");
  const [wholesaler, setWholeSalar] = useState([]);
  const [selectedWhosalererror, setSelectedWhosalerError] = useState("");
  const [loading, setLoading] = useState(false);
  const [accountType, setAccountType] = useState([]);
  const [selectedAccountType, setAccountTypeSelected] = useState();

  useEffect(() => {
    setCESelected(true);
    setACCSelected(true);
    coveredEntitiesData = [];
    accumulationData = [];
    drugWholeSaler.searchTerms.coveredEntityIDs = {};
    drugWholeSaler.searchTerms.accumulationIDs = {};
    drugWholeSaler.accumulations = [];
    updateStates(drugWholeSaler);
    setCEOptionSelected({ optionCESelected: '-1' });
    setOptionACCSelected({ optionACCSelected: '-1' });
    fetchCoveredEntities();
    serIsSubmitted(false);
    setAddwholesalers(false);
  }, [orgId, reset]);



  const fetchCoveredEntities = async () => {
   // let { organizationID } = orgId;
    if (typeof orgId !== "undefined" && orgId !== null) {
        coveredEntitiesData = [];
        drugWholeSaler.searchTerms.coveredEntityIDs = [];
        updateStates(drugWholeSaler);

        let selectedOrgId = orgId.organizationID;

        setLoading(false);
        try {
            const { data } = await API.get(`SBConfig/coveredentity/list/${selectedOrgId}`, {
                hasDefaultURL: true,
            });
            setLoading(false);
            if (data) {
                for (var x in data) {
                    coveredEntitiesData.push({ "value": data[x].coveredEntityID, "label": data[x].coveredEntityName });
                }
                console.log(data, "Data");
                drugWholeSaler.coveredEntities = data;

                if (coveredEntitiesData.length == 1) {
                    var ceData = [];
                    ceData.push(coveredEntitiesData[0])
                    drugWholeSaler.searchTerms.coveredEntityIDs = ceData;
                    window.selectedCoveredEntittyId = ceData;
                }
                if(window.selectedCoveredEntittyId.length > 0) {
                  drugWholeSaler.searchTerms.coveredEntityIDs = window.selectedCoveredEntittyId;
                }

                updateStates(drugWholeSaler);
                if (drugWholeSaler.searchTerms.coveredEntityIDs) {

                    var ceSelected = [];
                    ceSelected.optionCESelected = [];
                    for (var x in drugWholeSaler.searchTerms
                        .coveredEntityIDs) {
                        ceSelected.optionCESelected.push(
                            drugWholeSaler.searchTerms.coveredEntityIDs[x]
                        );
                    }
                    setCEOptionSelected(ceSelected);
                    let ceIds = drugWholeSaler.searchTerms.coveredEntityIDs.map(item => item["value"]);
                    fetchAccumulatorName(ceIds);
                }

            }
        }
        catch (err) {
            setLoading(false);
        }
    }

};
const handleCoverdEntityChange = (selectedces, setFieldValue, entity) => {
  
    let selected = [selectedces == null ? []: selectedces]
    
    if (selected) {
        window.selectedCoveredEntittyId = selected;
        window.selectedAccumulatorId = [];
        accumulationData = [];
        // setSelectedNdc('');
        drugWholeSaler.searchTerms.accumulationIDs = {};
        setCESelected(true);
        setCEOptionSelected({
            optionCESelected: selected.value
        });
        drugWholeSaler.coveredEntities = selected;
        setFieldValue('coveredEntityIDs', selected);
        drugWholeSaler.searchTerms.coveredEntityIDs = selected;
        if (Array.isArray(drugWholeSaler.searchTerms.coveredEntityIDs)) {
            accumulationIDs = {};
            drugWholeSaler.searchTerms.accumulationIDs = {};
        }
        let ceIds = drugWholeSaler.searchTerms.coveredEntityIDs.map(item => item["value"]);
        drugWholeSaler.searchTerms.coveredEntityIDs = ceIds;
        updateStates(drugWholeSaler);
        fetchAccumulatorName(ceIds);
        setOptionACCSelected({ optionACCSelected: '-1' });
    }
    else {
        setFieldValue('coveredEntityIDs', {});
        accumulationData = [];
        drugWholeSaler.coveredEntities = [];
        drugWholeSaler.searchTerms.coveredEntityIDs = {};
        drugWholeSaler.searchTerms.accumulationIDs = {};
        setCESelected(false);
        setACCSelected(false);
    }
    updateStates(drugWholeSaler);
};
const fetchAccumulatorName = async (coveredEntityIDs) => {
    if (coveredEntityIDs !== undefined && coveredEntityIDs.length > 0) {
        try {
            accumulationData = [];
            const payload = [];
            payload.AccumulatorEntityList = [coveredEntityIDs[0]];
            let AccumulatorEntityList = [payload.AccumulatorEntityList]
            const result = await API.get(`SBConfig/coveredentity/acclist/${AccumulatorEntityList}`,
                {
                    hasDefaultURL: true,
                }
            );
            debugger;
            if (result) {
              
                let accumulator = []
                accumulator = result.data;
                for (var x in accumulator) {
                    accumulationData.push({ "value": accumulator[x].accumulatorID, "label": accumulator[x].ceName });
                }
               
                if (accumulationData.length == 1) {
                  handleAccumulatorname(accumulationData[0]);
                        
                }
                //  else if (window.selectedAccumulatorId.length > 0) {
                //   drugWholeSaler.searchTerms.accumulationIDs =
                //     window.selectedAccumulatorId;
                //     handleAccumulatorname(window.selectedAccumulatorId[0]);
                // }
                drugWholeSaler.accumulations = result.data;
                updateStates(drugWholeSaler);
                // if (accumulationIDs.length > 0) {
                //     var accumulatorSelected = {};
                //     accumulatorSelected.optionACCSelected = [];
                //     for (var x in accumulationIDs) {
                //         accumulatorSelected.optionACCSelected.push(accumulationIDs[x]);
                //     }
                //     setOptionACCSelected({ accumulatorSelected});
                // }
            }
        } catch (error) {
            console.log(error.message);
        }
    }
};
const handleAccumulatorname = (selectedacs, setFieldValue, ac) => {
  debugger
  let selected = [selectedacs == null ? [] : selectedacs]
  window.selectedAccumulatorId = selected;
    if (selected) {
        setACCSelected(true);
        setOptionACCSelected({
            optionACCSelected: selected
        })
          // let val = selected.value;
          // setFieldValue('accumulatorID', val);
          // setFieldValue('accumulationIDs', selected);
        drugWholeSaler.searchTerms.accumulationIDs = selected;
        //fetchHospital(selected);
        SelectedAccumulator = selected[0].value;
        handleSubmit();
    }
    else {
        setACCSelected(true);
        //   setFieldValue('accumulationIDs', {});
        accumulationData = [];
        drugWholeSaler.coveredEntities = [];
        drugWholeSaler.searchTerms.accumulationIDs = {};
        drugWholeSaler.searchTerms.coveredEntityIDs = {};
        setCESelected(false);
    }
    updateStates(drugWholeSaler);
};
 
  const fetchAccountType = async () => {
    
    try {
      const { data } = await API.get(`SBConfig/TypeStatus/accountType`,
        {
          hasDefaultURL: true
        });

      if (data) {

        for (var x in data) {
          accountTypeData.push({ "id": data[x].id, "description": data[x].description });

        }
        setAccountType(data);
      }
      else {
        setAccountType([]);
      }

    }

    catch (err) {

    }
  }

  const handleAccountTypeChange = (e) => {
    
    const { value } = e.target;
    setAccountTypeSelected(value);
    drugWholeSaler.searchTerms.accountTypeId = value;
    console.log(value, "Account")
  };


  const toggleAddWholesaler = () => {
    setAddwholesalers(!addwholesalers);
  };
  const handelAddWholesaler = () => {
    toggleAddWholesaler()
  }

  const hasPermission = (code) => {
            return ModuleAccess("DRC", code);
        }
  const handleSubmit = async () => {
    debugger
     serIsSubmitted(true);
    // const { setSubmitting } = actions;
    let acIDs = [];
    let ceIDs = [];
    let accId = [];
   

    // if (searchTerms.coveredEntityIDs.length > 0) {
    //   val.coveredEntityIDs = searchTerms.coveredEntityIDs;
    //   setCESelected(true);
    // }
    // if (searchTerms.accumulationIDs.length > 0) {
    //   val.accumulationIDs = searchTerms.accumulationIDs;
    //   setACCSelected(true);
    // }

    // if(searchTerms.accountTypeId.length > 0){

    //   val.accountTypeId = searchTerms.accountTypeId;
    // }


    for (var x in searchTerms.accumulationIDs) {
      var rw = searchTerms.accumulationIDs[x];
      acIDs.push(rw.value);
    }
    for (var x in searchTerms.coveredEntityIDs) {
      var rw = searchTerms.coveredEntityIDs[x];
      ceIDs.push(rw.value);
    }
  


    if (ceIDs.length == 0) {
      setCESelected(false);

      //return setSubmitting(false);
    }
    if (acIDs.length == 0) {
      setACCSelected(false);
    }
  
    if (SelectedAccumulator != "" && SelectedAccumulator != undefined){
    //const values = cloneDeep(val);
      const values = {};
    //if (ceIDs > [0]) values.coveredEntityIDs = val.coveredEntityIDs;
    if (ceIDs > [0]) values.CoveredEntityIDs = ceIDs;
    if (acIDs > [0]) values.accumulationIDs = acIDs;
     values.accountTypeId = drugWholeSaler.searchTerms.accountTypeId;



    drugWholeSaler.search.currentPage = 1;
    updateStates(drugWholeSaler);
    await onSearch(values);
   // setSubmitting(false);
  }
  };

  const handleReset = ({ resetForm }) => {
    serIsSubmitted(false);
    setCESelected(true);
    setACCSelected(true);
    setAccountTypeSelected("");
    
    accumulationData = [];
    window.selectedCoveredEntittyId = "";
    window.selectedAccumulatorId = "";
    onReset();
    // resetForm();
    setCEOptionSelected({ optionCESelected: "-1" });
    setOptionACCSelected({ optionACCSelected: "-1" });
    drugWholeSaler.searchTerms.coveredEntityIDs = {};
    drugWholeSaler.searchTerms.accumulationIDs = {};
    updateStates(drugWholeSaler);
    resetStates("drugWholeSaler");
  }

  let addDisable = selectedCEOption.optionCESelected != '-1' && drugWholeSaler.searchTerms.accumulationIDs.length > 0 && drugWholeSaler.searchTerms.coveredEntityIDs.length > 0  ? false : true;

  return (
    <div>
        <div className="d-flex justify-content-between">
                <h5 className="f-16 text-primary font-weight-700">
                  Search Wholesalers
                </h5>
                <div>
                <Button
                     
                     color="primary"
                     className="reset"
                     hidden={(hasPermission('AD'))}
                     onClick={handelAddWholesaler}
                     disabled={addDisable}
   
                   >
                       <span className="right_5">
                        <img src={plus} alt="" />
                      </span>{" "}
                     Add
                   </Button>
                  
                </div>
              </div>
      <Formik
        initialValues={searchTerms}
        onSubmit={handleSubmit}
   
        children={(props) => {
          const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
          return (
            <div hidden={collapseSider}>
              <div>
                <Row sm={5} className="d-flex" style={{}}>
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="coveredentity">Covered Entity</Label>
                      <ReactSelect
                        name="coveredentity"
                        id="coveredentity"
                        options={coveredEntitiesData}
                        // isMulti
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        optionSelected={true}
                        //isClearable={true}
                        components={{
                          Option,
                        }}
                        isSearchable="true"
                        onChange={(value, cp) =>
                          handleCoverdEntityChange(value, setFieldValue, cp)
                        }
                        value={selectedCEOption.optionCESelected}
                        className="claim_info required"
                        maxMenuHeight={220}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 99,
                          }),
                          option: (provided) => ({
                                      ...provided,
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }),
                        }}
                      />
                      {!hasCESelected ? (
                        <div className="text-danger f-12 position-absolute">
                          {coveredEntityError}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="accumulator">Accumulator</Label>
                      <ReactSelect
                        name="accumulator"
                        id="accumulator"
                        options={accumulationData}
                        // isMulti
                        closeMenuOnSelect={true}
                        isDisabled = {accumulationData.length ==1}
                        hideSelectedOptions={false}
                        optionSelected={true}
                        isClearable={true}
                        components={{
                          Option,
                        }}
                        // isSearchable="true"
                        onChange={(value, ac) =>
                          handleAccumulatorname(value, setFieldValue, ac)
                        }
                        value={selectedACCOption.optionACCSelected}
                        className="claim_info required"
                        maxMenuHeight={220}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 99,
                          }),
                          option: (provided) => ({
                                      ...provided,
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }),
                        }}
                      />
                      {(!hasACCSelected && isSubmited) || (hasCESelected && isSubmited && selectedACCOption.optionACCSelected == "-1") ? (
                        <div className="text-danger f-12 position-absolute">
                          {accumulationError}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="accounttype">Account Type</Label>
                      <Field
                        // className="required"
                        id="accounttype"
                        name="accounttype"
                        type="select"
                        placeholder="Select"
                        autoComplete="off"
                        options={accountType}
                        value={selectedAccountType}
                        component={FormikSelectField}
                        defaultoption="(All)"
                        keys={{
                          id: "id",
                          label: "description",
                        }}
                        onChange={(e) => handleAccountTypeChange(e)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
              <div hidden={""}>
                <Row
                  style={{
                    justifyContent: "flex-end",
                  }}
                >
                  <Col md="auto" className="d-flex">
                    <Label>{""}</Label>
                    {/* <Button
                     
                      color="primary"
                      className=""
                      onClick={handelAddWholesaler}
                      disabled={addDisable}
    
                    >
                      Add
                    </Button> */}
                    <Button
                   
                      color="primary"
                      className="search"
                      onClick={handleSubmit}

                
                    >
                      <span className="right_5">
                                          <img src={search} alt="" />
                                        </span>{" "}
                      Search
                    </Button>
                    <Button
                     
                      color="primary"
                      className="reset"
                      onClick={handleReset}

                    >
                      <span className="right_5">
                                          <img src={reseticon} alt="" />
                                        </span>{" "}
                      Reset
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          );
        }}
      ></Formik>
      <Drawer
        direction="end"
        title="Add Wholesalers"
        isOpen={addwholesalers}
        toggle={toggleAddWholesaler}
        size="lg"
      >
        <AddWholesalers SelectedAccumulator = {SelectedAccumulator} orgId={orgId} refetch={refetch} toggleAddWholesaler={toggleAddWholesaler}/>
      </Drawer>
    </div>
  );
}

export default SearchContainer